import React from "react";
import PageChrome, { INK, BLUE, LIME } from "./components/PageChrome";

const CONTACT_EMAIL = "hola@thedebtguy.com";
const UPDATED = "junio de 2026";

const Section = ({ n, title, children }) => (
  <section style={{ marginTop: 40 }} data-testid={`terms-section-${n}`}>
    <h2 className="cg-h3" style={{ marginBottom: 14 }}>
      <span style={{ color: BLUE, marginRight: 12 }}>{n}.</span>
      {title}
    </h2>
    <div style={{ fontSize: 15.5, lineHeight: 1.75, color: INK, opacity: 0.86 }}>{children}</div>
  </section>
);

const P = ({ children }) => <p style={{ margin: "0 0 14px" }}>{children}</p>;
const UL = ({ items }) => (
  <ul style={{ margin: "0 0 14px", paddingLeft: 22 }}>
    {items.map((it, i) => (
      <li key={i} style={{ marginBottom: 8 }}>{it}</li>
    ))}
  </ul>
);

export default function Terminos() {
  return (
    <PageChrome testid="terms-page">
      <div style={{ maxWidth: 820, margin: "0 auto", padding: "72px 24px 100px" }}>
        <p className="cg-mono cg-eyebrow" data-testid="terms-eyebrow">Legal · Términos</p>
        <h1 className="cg-h1" style={{ marginTop: 14 }}>Términos y Condiciones</h1>
        <p style={{ marginTop: 18, fontSize: 14, opacity: 0.55 }} className="cg-mono">
          Última actualización: {UPDATED}
        </p>

        {/* Disclaimer destacado: no es asesoría financiera */}
        <div
          data-testid="terms-disclaimer"
          style={{
            marginTop: 34, border: `2px solid ${INK}`, borderRadius: 16,
            background: LIME, boxShadow: `5px 5px 0 ${INK}`, padding: "24px 26px",
          }}
        >
          <p className="cg-mono" style={{ marginBottom: 8 }}>Aviso importante</p>
          <p style={{ margin: 0, fontSize: 15.5, lineHeight: 1.65, fontWeight: 700 }}>
            El contenido de The Debt Guy es educativo e informativo. No constituye asesoría
            financiera, legal, contable ni de inversión personalizada. Toda decisión de
            financiamiento o estructuración de capital es tu responsabilidad; te recomendamos
            consultar a un asesor profesional antes de actuar.
          </p>
        </div>

        <Section n={1} title="Aceptación de los términos">
          <P>
            Al acceder y utilizar este sitio, adquirir cualquier producto o suscribirte a nuestros
            servicios, aceptas quedar obligado por estos Términos y Condiciones. Si no estás de
            acuerdo, por favor no utilices el sitio ni los servicios.
          </P>
        </Section>

        <Section n={2} title="Descripción de los servicios">
          <P>
            The Debt Guy ofrece contenido educativo, plantillas, cursos, membresías (The Capital
            Circle), certificaciones, programas por cohorte y servicios de estructuración de capital
            (mandatos 1:1 y Capital Markets as a Service) enfocados en levantar y estructurar deuda
            y capital para startups, PyMEs, fintechs, SOFOMs, fondos e instituciones financieras.
          </P>
        </Section>

        <Section n={3} title="Pagos, suscripciones y facturación">
          <P>Los pagos se procesan de forma segura a través de nuestro proveedor de pagos (Stripe). Al comprar aceptas que:</P>
          <UL items={[
            "Los precios se muestran en USD; algunos productos incluyen una referencia aproximada en MXN.",
            "Las suscripciones (por ejemplo, The Debt Circle) se renuevan automáticamente al final de cada período hasta que las canceles.",
            "Puedes cancelar tu suscripción en cualquier momento; la cancelación aplica al final del período ya pagado.",
            "Los productos que se adquieren por aplicación (cohortes, mandatos 1:1) se rigen por los términos particulares que se acuerden en cada caso.",
          ]} />
        </Section>

        <Section n={4} title="Garantía y reembolsos">
          <P>
            Los cursos y productos digitales con garantía de satisfacción cuentan con un período de
            14 días para solicitar reembolso, siempre que no se haya consumido una parte sustancial
            del contenido. Las membresías pueden cancelarse para evitar renovaciones futuras. Para
            solicitar un reembolso escribe a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="cg-link" style={{ color: BLUE }}>
              {CONTACT_EMAIL}
            </a>.
          </P>
        </Section>

        <Section n={5} title="Propiedad intelectual">
          <P>
            Todo el contenido del sitio y de los productos (textos, videos, plantillas, marcas,
            diseño y materiales) es propiedad de The Debt Guy o se usa con licencia. Se te
            otorga una licencia personal e intransferible para uso individual. No puedes revender,
            redistribuir ni reproducir el contenido sin autorización por escrito.
          </P>
        </Section>

        <Section n={6} title="Uso aceptable">
          <P>Al usar el sitio te comprometes a no:</P>
          <UL items={[
            "Compartir tus credenciales de acceso o el contenido de pago con terceros.",
            "Utilizar el sitio con fines ilícitos o que infrinjan derechos de terceros.",
            "Intentar vulnerar la seguridad o el funcionamiento del sitio.",
          ]} />
        </Section>

        <Section n={7} title="Sin garantía de resultados">
          <P>
            No garantizamos resultados específicos (por ejemplo, cerrar una ronda, obtener una línea
            de crédito o un term sheet). Los resultados dependen de múltiples factores fuera de
            nuestro control, incluyendo tu ejecución, tu operación y las condiciones de mercado.
          </P>
        </Section>

        <Section n={8} title="Limitación de responsabilidad">
          <P>
            En la máxima medida permitida por la ley, The Debt Guy no será responsable por daños
            indirectos, incidentales o consecuentes derivados del uso del sitio o de los servicios.
            Nuestra responsabilidad total se limita al monto que hayas pagado por el producto o
            servicio correspondiente.
          </P>
        </Section>

        <Section n={9} title="Modificaciones y cancelación">
          <P>
            Podemos actualizar estos Términos, así como modificar o descontinuar productos, en
            cualquier momento. Los cambios entran en vigor al publicarse en esta página.
          </P>
        </Section>

        <Section n={10} title="Ley aplicable y contacto">
          <P>
            Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier
            duda o notificación, escríbenos a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="cg-link" style={{ color: BLUE }}>
              {CONTACT_EMAIL}
            </a>.
          </P>
        </Section>
      </div>
    </PageChrome>
  );
}
